import { render, staticRenderFns } from "./Spectator.vue?vue&type=template&id=95ecfa38&scoped=true&"
import script from "./Spectator.vue?vue&type=script&lang=js&"
export * from "./Spectator.vue?vue&type=script&lang=js&"
import style0 from "./Spectator.vue?vue&type=style&index=0&id=95ecfa38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ecfa38",
  null
  
)

export default component.exports